export enum MessageType {
	response = 'response',
	request = 'request',
	notif = 'notif',
	streamState = "stream-state"
}